import React, { useEffect } from 'react';
import imgDBParams from '../../../assets/Kiponos-DB-Params.webp'
import imgMosheAvatar from '../../../assets/Moshe-Avatar.webp'
import LandJoinForm from '../LandJoinForm';
import './Land3.css';

const Land3 = () => {

  const SignupButton = ({ label }) => {
    const scrollToSignupFooter = () => {
      const element = document.getElementById('signup-footer');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    };

    return (
      <button className="signup-button" onClick={scrollToSignupFooter}>
        {label || 'Sign Up'}
      </button>
    );
  };

  useEffect(()=>{
    document.title = 'Kiponos.io - Real-Time Config'
  }, []);

  return (
    <div className='land3'>

      <header>
        <div className="logo">Kiponos.io</div>
        <nav className="nav-links">
          <a href="#features">Features</a>
          <a href="#pricing">Pricing</a>
          <a href="#about">About Us</a>
          <a href="#docs">Docs</a>
          <a href="https://kiponos.io/login">Login</a>
        </nav>
      </header>


      <section className="hero">        
        <h1>Say goodbye to config chaos</h1>
        <p>
          Kiponos lets teams manage application configs live. No restarts.
          Java SDK.
        </p>

        <LandJoinForm withTags={false} cta='Free Single Team'/>
        <div className="signup-notes">
          <p>No credit cards needed</p>
          <p>Single Team Free Forever.</p>
          <p>Plenty of Envs</p> 
        </div>

        <img className="screenshot" src={imgDBParams} alt="Kiponos Web Admin Screenshot" />
      </section>

      <h1>Features</h1>
      <section className="features" id="features">        
        <div><strong>Live Updates</strong><br />Changes take effect instantly via WebSockets.</div>
        <div><strong>Multi-Env Support</strong><br />Manage Dev, Staging, and Prod separately.</div>
        <div><strong>No Restarts</strong><br />Update configs on the fly without downtime.</div>
        <div><strong>Web Admin</strong><br />Modern UI to view, audit, and manage keys.</div>
        <div><strong>Team Collaboration</strong><br />Invite your team to manage together.</div>
        <div><strong>Minimal SDK</strong><br />Pure Java & React clients, lightweight by design.</div>
      </section>
      <p/>

      <h1>Pricing</h1>
      <section className='pricing' id='pricing'>      
        <div className="pricing-grid">
          <div className="pricing-tier">
            <h3>Free</h3>
            <p>Single Team with plenty members, real-time task collaboration, env hierarchies</p>
            <strong>$0</strong>
            <p />
            <SignupButton label="Start Free Team" />            
          </div>
          <div className="pricing-tier">
            <h3>Project</h3>
            <p>Multiple teams, role per team access, real-time 3D Task Manager</p>
            <strong>$46/month</strong>
            <p />
            <SignupButton label="Start Project" />
          </div>
          <div className="pricing-tier">
            <h3>Enterprise</h3>
            <p>Multi-projects, SLA, SSO, audit, metrics, analytics, custom plans</p>
            <strong>Contact Us</strong>
          </div>
        </div>        
      </section>


      <h1>About Us</h1>
      <section className="about" id="about">
        <p>
          Kiponos.io was born from the desire to eliminate the pain of configuration management in modern applications.
          Founded by developers who experienced the complexity of managing environment-specific configs, Kiponos delivers
          a futuristic, real-time solution powered by WebSockets, Redis, and minimal SDKs for Java and React.
        </p>
        <p>
          Inspired by the idea of making systems feel more alive and interactive, Kiponos treats configuration not as static files,
          but as a living system you can see, manage, and evolve while your app is running. We aim to empower developers and DevOps
          with clear visibility, zero downtime updates, and intuitive tools — all while keeping infrastructure simple and lightweight.
        </p>
        <p>
          Kiponos comes from an ancient Temple Gate served for enter and exit - symbolizing access, structure, and clarity.
          Our mission is to build a config system that feels like it belongs on a spaceship dashboard: elegant, responsive, and human-centric while still embracing values and traditions.
        </p>        
      </section>

      <div className='signup-footer' id='signup-footer'>
        <LandJoinForm withTags={false} cta='Free Single Team'/>
        <div className="signup-notes">
          <div>Single Team Free Forever</div>
          <div>No credit cards needed</div>
          <div>Plenty Envs and Profiles</div>
        </div>
      </div>


      <h1>Docs</h1>
      <section style={{textAlign: 'center', marginBottom: 64}} id='docs' className='docs'>
        <div className="docs-container">
          SDK Usage and Examples: <a href='https://github.com/kiponos-io/kiponos-io' className="docs-link">kiponos-io at GitHub</a>
        </div>
      </section>


      <h1>Contact</h1>
      <section className='contact' id='contact'>
        <p style={{ display: 'flex', alignItems: 'center' }}>
          <strong style={{ width: '100px', color: '#555' }}>Email:</strong> 
          <a href="mailto:HelpDesk@Kiponos.io" style={{ color: '#007BFF' }}>HelpDesk@Kiponos.io</a>
        </p>
        <p style={{ display: 'flex', alignItems: 'center' }}>
          <strong style={{ width: '100px', color: '#555' }}>Phone:</strong> 
          <a href="tel:+972544602111" style={{ color: '#007BFF' }}>+972-54-4602111</a>
        </p>
      </section>

      <p className="about-quote">
          “We built Kiponos so devs could stop dreading config changes and start enjoying them — live, safe, and visible.”
      </p>

      <div className="founder-info">
        <img
          className="founder-avatar"
          src={imgMosheAvatar}
          alt="Moshe Avdiel"
        />
        <div className="founder-signature">
          Moshe Avdiel<br />
          Tech Lead at Kiponos.io
        </div>
      </div>

      <footer>
        <div className="footer-top">
          <div className="badges">
            <img src='https://img.shields.io/badge/secured-SSL-green?style=plastic' alt='Secured-SSL' />
            <img src='https://img.shields.io/badge/secured-WSS-green?style=plastic' alt='Secured-WSS' />
            <img src='https://img.shields.io/badge/secured-JWT-green?style=plastic' alt='Secured-JWT' />
            <img src='https://img.shields.io/badge/RBAC-Per_Team-green?style=plastic' alt='Secured-Role_Based_Access' />

            <img src="https://img.shields.io/badge/sdk-React-blue?style=plastic" alt="React SDK" /> 
            <img src="https://img.shields.io/badge/sdk-Java-blue?style=plastic" alt="Java SDK" />            
          </div>
          <div className="footer-links">
            <a href="#privacy">Privacy</a>
            <a href="#terms">Terms</a>
            <a href="#contact">Contact</a>
          </div>
        </div>
        <div style={{ marginTop: '1rem', color: '#999' }}>
          © 2022 - 2025 Kiponos.io - All rights reserved.
        </div>
      </footer>

    </div>
  );
};

export default Land3;